export const MIN_PHOTO = 20;
export const MAX_PHOTO = 60;
export const SITE_URL = 'https://kindbot.pro/';
export const MAIN_COLOR = '#cf024c';